
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 12H0v1h6v-1zM6 7H0v1h6V7zM6 2H0v1h6V2zM14 12H8v1h6v-1zM14 7H8v1h6V7zM14 2H8v1h6V2z","fill":"#fff"}})])
          )
        }
      }
    